import { regexPatterns, useWidgetContext } from '@dxp-module/common';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputNames } from '../enum/InputNames';
import useLogin from './useLogin';
import useLoginContext from './useLoginContext';
const defaultValues = {
    emailAddress: '',
    password: '',
};
// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
const useLoginForm = () => {
    const { formInputOptions, errors } = useLoginContext();
    const { configuration: { introducedEmail }, } = useWidgetContext();
    if (introducedEmail) {
        defaultValues.emailAddress = introducedEmail;
    }
    const schema = yup
        .object()
        .shape({
        emailAddress: yup
            .string()
            .required(errors?.emptyEmail)
            .matches(regexPatterns.emailAddress, errors?.invalidEmailFormat),
        password: yup.string().required(errors?.invalidPassword),
    })
        .required();
    const { control, getValues, handleSubmit, setError, clearErrors, setValue, formState, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        shouldUnregister: true,
        defaultValues,
        resolver: yupResolver(schema),
    });
    const { login, error, loading } = useLogin();
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const handleFormSubmit = () => {
        clearErrors();
        const { emailAddress, password } = getValues();
        !loading && login(emailAddress, password);
    };
    useEffect(() => {
        if (formInputOptions) {
            Object.entries(formInputOptions).forEach(([key, option]) => {
                setValue(key, option?.value || '');
            });
        }
    }, [formInputOptions]);
    useEffect(() => {
        const { emailAddress, password } = getValues();
        const hasEmptyFields = !emailAddress.trim().length || !password.trim().length;
        const hasError = !formState.isValid;
        setIsSubmitDisabled(hasEmptyFields || hasError || loading);
    }, [formState]);
    useEffect(() => {
        if (error) {
            if (!formInputOptions?.emailAddress?.readonly) {
                setError(InputNames.EMAIL, {
                    message: errors?.invalidEmailFormat,
                });
            }
            setError(InputNames.PASSWORD, {
                message: errors?.invalidPassword,
            });
        }
    }, [error]);
    return {
        loading,
        control,
        isSubmitDisabled,
        handleFormSubmit: handleSubmit(handleFormSubmit),
    };
};
export default useLoginForm;
//# sourceMappingURL=useLoginForm.js.map